import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// TODO: Add translations.
export const UnsupportedFieldTypeFallback = () => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            p={3}
            m={2}
            bgcolor="background.paper"
            boxShadow={3}
            borderRadius="borderRadius"
        >
            <Typography variant="h6" color="error" gutterBottom={true}>
                {t('formGenerator.unsupportedFieldType.title')}
            </Typography>
            <Typography variant="body1" gutterBottom={true}>
                {t('formGenerator.unsupportedFieldType.message')}
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
            >
                {t('formGenerator.unsupportedFieldType.reloadButton')}
            </Button>
        </Box>
    );
};
